import { render, staticRenderFns } from "./SetterView.vue?vue&type=template&id=2d2b93a4&scoped=true&"
import script from "./SetterView.vue?vue&type=script&lang=js&"
export * from "./SetterView.vue?vue&type=script&lang=js&"
import style0 from "./SetterView.vue?vue&type=style&index=0&id=2d2b93a4&lang=scss&scoped=true&"
import style1 from "./SetterView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b93a4",
  null
  
)

export default component.exports